import { Translations } from '../translations.model';

export const ES: Translations = {
  brand: 'Benji Rodríguez',
  role: 'Software Engineer',
  heroGreeting: 'Hola, soy',
  heroFirstName: 'Benjamin',
  heroLastName: 'Rodriguez',
  heroHeadline: 'Software Engineer especializado en TypeScript',
  heroLead:
    'Desarrollo aplicaciones web y sistemas empresariales de extremo a extremo, trabajando con tecnologías modernas de frontend, backend, bases de datos y cloud.',
  viewExperience: 'Ver experiencia',
  viewProjects: 'Ver proyectos',
  downloadCv: 'Descargar CV',
  contactMe: 'Contactarme',
  connect: 'Conectemos:',
  aboutTitle: 'Sobre mí',
  aboutParagraphs: [
    'Soy Software Engineer con experiencia en desarrollo frontend y backend, especializado principalmente en TypeScript. He trabajado construyendo y manteniendo aplicaciones empresariales utilizando Angular, React, NestJS, Express y Node.js, además de bases de datos como PostgreSQL y MySQL.',
    'También cuento con experiencia trabajando con AWS, Docker, Linux, integraciones con servicios externos y despliegues en producción. Adicionalmente, tengo conocimientos de Java con Spring Boot y Go utilizando Gin y GORM.',
    'A lo largo de mi experiencia he participado en diferentes etapas del ciclo de vida del software, desde la implementación de requerimientos y desarrollo de funcionalidades hasta integraciones, despliegues, resolución de incidencias y soporte de sistemas en producción.',
    'Quiero continuar creciendo como Software Engineer, profundizando especialmente en backend, arquitectura, cloud y sistemas distribuidos.',
  ],
  aboutStats: [
    { value: '~3', label: 'Años de experiencia' },
    { value: 'TypeScript', label: 'Stack principal' },
    { value: 'Full Stack', label: 'Frontend y backend' },
    { value: 'Panamá', label: 'Ubicación', emoji: '🇵🇦' },
  ],
  experienceTitle: 'Experiencia',
  experiences: [
    {
      company: 'Cliente confidencial',
      title: 'Software Engineer',
      type: 'Part-time',
      period: 'Marzo 2026 — Actualidad',
      location: 'Remoto',
      current: true,
      description:
        'Desarrollo y mantenimiento de aplicaciones backend y web para un cliente confidencial, participando también en integraciones, infraestructura y soporte de producción.',
      responsibilities: [
        'Desarrollo y mantenimiento con Ruby on Rails.',
        'Trabajo con PostgreSQL, incluyendo optimización de consultas SQL.',
        'Desarrollo con JavaScript y TypeScript.',
        'Integraciones con servicios de terceros.',
        'Implementación y mantenimiento de procesos de negocio.',
        'Generación y mantenimiento de reportes.',
        'Despliegues a producción.',
        'Administración y soporte de infraestructura.',
        'Resolución de incidencias en producción.',
      ],
      technologies: [
        'Ruby on Rails',
        'PostgreSQL',
        'JavaScript',
        'TypeScript',
        'AWS',
        'Linux',
        'Nginx',
        'Puma',
        'Sidekiq',
        'Redis',
      ],
    },
    {
      company: 'SMS Sudamérica',
      title: 'Angular Front-End Developer',
      type: 'Mid-Level',
      period: 'Octubre 2025 — Actualidad',
      location: 'Remoto',
      current: true,
      description:
        'Desarrollo y mantenimiento de aplicaciones empresariales utilizando Angular y TypeScript.',
      responsibilities: [
        'Desarrollo de nuevas funcionalidades.',
        'Creación de componentes reutilizables.',
        'Integración con APIs REST.',
        'Resolución de incidencias.',
        'Mantenimiento y mejora de funcionalidades existentes.',
        'Colaboración con equipos de backend y otras áreas.',
        'Uso de Docker dentro del flujo de desarrollo.',
      ],
      technologies: ['Angular', 'TypeScript', 'CSS', 'Docker', 'REST APIs'],
    },
    {
      company: 'Etyalab',
      title: 'Full-Stack Developer',
      period: 'Mayo 2024 — Octubre 2025',
      location: 'Panamá',
      description:
        'Durante esta etapa trabajé como desarrollador Full Stack participando en el desarrollo y mantenimiento de diferentes aplicaciones empresariales.',
      responsibilities: [
        'Desarrollo frontend y backend.',
        'Implementación de nuevas funcionalidades.',
        'APIs e integraciones.',
        'Mantenimiento de aplicaciones existentes.',
        'Trabajo con bases de datos PostgreSQL.',
        'Despliegues y soporte utilizando AWS y Docker.',
        'Participación en sistemas relacionados con pagos, dashboards, gestión de turnos y procesos operativos.',
      ],
      technologies: [
        'React',
        'Angular',
        'Vue',
        'NestJS',
        'LoopBack',
        'Express.js',
        'PostgreSQL',
        'AWS EC2',
        'AWS S3',
        'Docker',
        'Bash',
      ],
    },
    {
      company: 'Maxia',
      title: 'Full-Stack Developer',
      type: 'Practicante',
      period: 'Febrero 2023 — Junio 2023',
      location: 'Panamá',
      description:
        'Ingresé como practicante como parte de una asignatura de la Universidad Tecnológica de Panamá. Participé en proyectos de desarrollo web desempeñándome como desarrollador Full Stack, trabajando principalmente con React y backend web.',
      responsibilities: [
        'Desarrollo de funcionalidades web.',
        'Trabajo frontend con React.',
        'Apoyo en backend.',
        'Mantenimiento básico de aplicaciones.',
        'Aplicación de buenas prácticas de desarrollo.',
      ],
      technologies: ['React', 'PHP'],
    },
  ],
  referencesTitle: 'Referencias de código',
  referencesLead:
    'Estos repositorios muestran lo que he experimentado en backend, frontend y arquitectura. No están desplegados; el código está en GitHub.',
  viewOnGithub: 'Ver repositorio',
  viewAllGithub: 'Ver GitHub',
  references: [
    {
      title: 'EventFlow',
      description:
        'Flujo de pedidos con outbox transaccional: la orden y el evento se guardan en la misma transacción de PostgreSQL, un publisher los envía a Kafka y el consumidor registra notificaciones. Aquí practiqué consistencia, recuperación si Kafka no está disponible, Docker Compose, Flyway y tests con Testcontainers.',
      technologies: [
        'Java',
        'Quarkus',
        'Kafka',
        'PostgreSQL',
        'React',
        'TypeScript',
        'Docker',
      ],
      repositoryUrl: 'https://github.com/DevBeex/eventflow',
    },
    {
      title: 'Search Engine',
      description:
        'Motor de búsqueda en memoria con Spring Boot: índice invertido, lecturas concurrentes con ReadWriteLock, eventos de Spring para analítica y caché LRU. También containericé la app con un multi-stage Dockerfile.',
      technologies: ['Java', 'Spring Boot', 'Docker'],
      repositoryUrl: 'https://github.com/DevBeex/search-engine',
    },
    {
      title: 'Taskflow',
      description:
        'Backend tipo tablero (inspirado en Trello) con Spring Boot, JPA, Spring Security, Flyway y PostgreSQL. El repositorio concentra la parte de API y persistencia de ese experimento.',
      technologies: ['Java', 'Spring Boot', 'PostgreSQL', 'Flyway'],
      repositoryUrl: 'https://github.com/DevBeex/taskflow',
    },
    {
      title: 'Music',
      description:
        'Aplicación Angular en TypeScript con Tailwind. En este repo exploré la estructura de un frontend moderno y la integración con AWS Amplify.',
      technologies: ['Angular', 'TypeScript', 'Tailwind CSS', 'AWS Amplify'],
      repositoryUrl: 'https://github.com/DevBeex/music',
    },
    {
      title: 'API REST con Node.js',
      description:
        'API REST con Express organizada en rutas, middlewares, schemas y services. Fue un espacio para practicar diseño de endpoints, validación y separación de responsabilidades en Node.js.',
      technologies: ['Node.js', 'Express.js', 'JavaScript'],
      repositoryUrl: 'https://github.com/DevBeex/APIrest-with-nodejs-express',
    },
  ],
  skillsTitle: 'Skills / Stack',
  skillCategories: {
    languages: 'Lenguajes',
    frontend: 'Frontend',
    backend: 'Backend',
    database: 'Bases de datos',
    devops: 'Cloud / DevOps',
    tools: 'Herramientas',
  },
  educationTitle: 'Educación',
  educationDegree: 'Licenciatura en Ingeniería de Software',
  educationInstitution: 'Universidad Tecnológica de Panamá',
  educationPeriod: '2019 — 2025',
  certificationsTitle: 'Certificaciones',
  oracleCertificationName: 'Oracle Certified Associate (OCA)',
  oracleCertificationCredential: 'Java SE 8 Programmer',
  oracleCertificationIssuer: 'Oracle',
  oracleCertificationUrl:
    'https://catalog-education.oracle.com/ords/certview/sharebadge?id=B16D2EAD04DF07F5E4E2915729C3FC28917D75ED7DC1365D6BF1269C7099683E',
  coursesTitle: 'Cursos',
  platziCourses: [
    {
      name: 'Java Spring',
      url: 'https://platzi.com/p/catsdevops/curso/1996-java-spring/diploma/detalle/',
    },
    {
      name: 'Backend con Node.js',
      url: 'https://platzi.com/p/catsdevops/curso/2485-backend-nodejs/diploma/detalle/',
    },
    {
      name: 'Fundamentos de Node.js',
      url: 'https://platzi.com/p/catsdevops/curso/1759-fundamentos-node/diploma/detalle/',
    },
    {
      name: 'JavaScript práctico',
      url: 'https://platzi.com/p/catsdevops/curso/3271-course/diploma/detalle/',
    },
  ],
  languagesTitle: 'Idiomas',
  spokenLanguages: [
    { name: 'Español', level: 'Nativo' },
    { name: 'Inglés', level: 'A2 / En formación' },
  ],
  contactTitle: '¿Hablamos?',
  contactLead:
    'Estoy abierto a nuevas oportunidades como Software Engineer, Full Stack Developer, Frontend Developer o Backend Developer.',
  currentBadge: 'Actual',
  demo: 'Demo',
  code: 'Código',
  navigation: 'Navegación',
  madeWith: 'Hecho con ♥ y código',
  rights: '© 2026 Benjamin Rodriguez. Todos los derechos reservados.',
  navHome: 'Inicio',
  navAbout: 'Sobre mí',
  navExperience: 'Experiencia',
  navReferences: 'Referencias',
  navSkills: 'Skills',
  navEducation: 'Educación',
  navContact: 'Contacto',
  openMenu: 'Abrir menú',
  closeMenu: 'Cerrar menú',
};
